import type { LandingPersona } from '@/hooks/useLandingPersona'

interface Props {
  persona: LandingPersona
}

export default function LandingDayInLife({ persona }: Props) {
  return (
    <section className="lp-section" id="day-in-life" style={{ background: 'rgba(255,255,255,0.012)' }}>
      <div className="lp-container">
        <div className="lp-section-header">
          <div className="lp-eyebrow">A day in the life</div>
          <h2>
            Same morning.{' '}
            <span style={{ color: persona.primary, textShadow: `0 0 40px ${persona.glow}` }}>
              Different life.
            </span>
          </h2>
        </div>

        <div className="lp-dayinlife">
          <div className="lp-card lp-dayinlife-pane">
            <div className="lp-dayinlife-eyebrow lp-dayinlife-before">Before {persona.name}</div>
            <p>
              You wake up. Before you can get to your first client you’ve already opened
              Ads Manager, tried to decode whether your CTR is good or bad, logged into
              Stripe to see if yesterday cleared, and scrolled through industry news
              hoping something matters.
            </p>
            <p>
              You’re 90 minutes in and you haven’t done any actual work yet.
            </p>
          </div>

          <div
            className="lp-card lp-dayinlife-pane"
            style={{
              borderColor: `color-mix(in srgb, ${persona.primary} 45%, transparent)`,
              boxShadow: `0 24px 60px -28px ${persona.glow}`,
            }}
          >
            <div
              className="lp-dayinlife-eyebrow"
              style={{ color: persona.primary }}
            >
              With {persona.name}
            </div>
            <p>
              You wake up. Your briefing is waiting — 90 seconds, on the phone, in your
              inbox, or on the dashboard. Ads up 12% this week. Two trials converted
              overnight. ROAS holding at 2.4×. One ad set is fatiguing — recommend
              pausing it today.
            </p>
            <p>
              First client at 8am. You walk in knowing exactly where you stand — and
              you’re actually ready. Anything else you want to know, you pick up the
              phone and ask.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
